export enum DomainStatusEnum {
  verified = 'dashboard.settings.mailing.dns_settings_status_verified',
  pending = 'dashboard.settings.mailing.dns_settings_status_pending',
  pending_dmarc = 'dashboard.settings.mailing.dns_settings_status_pending_dmarc',
}
